<template>
  <div class="card">
    <div class="card-header">
      <div class="flex justify-between">
        <div>
          <h2 class="card-heading">Knowledge Center</h2>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-2">
        <div v-for="(category, index) in categories" :key="index">
          <div class="font-medium text-sm text-white bg-primary py-2.5 px-4 rounded-t-lg">
            {{ category.title }}
          </div>
          <div class="text-xs divide-y divide-slate-200">
            <div
                v-for="(item, itemIndex) in category.items"
                :key="itemIndex"
            >
              <a :href="item.link" target="_blank"
                 class="block w-full py-2 px-4 bg-slate-100 hover:cursor-pointer hover:text-primary hover:bg-slate-200"
                 rel="noopener noreferrer">
                <p>{{ item.name }}</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import BandharuService from "@/services/bandharu.service";

@Component({
  components: {},
})
export default class KnowledgeCenter extends Vue {
  private service = new BandharuService();

  private categories = [
    {
      title: "Marine and Security",
      items: [
        { name: "Pre-Arrival Notification of Security Form", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Pre-Arrival-Notification-of-Security-Form.pdf" },
        { name: "Keywall Gavaidhu", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/marineQuay.pdf" },
        { name: "Salvage Operation Gavaidhu", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/salvageops.pdf" },
        { name: "Application Form For Male' Commercial Harbour Entry Pass", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Application-Form-For-Male'-Commercial-Harbour-Entry-Pass-2.pdf" },
        { name: "Aamunna Behey Gavaid", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Aamunna-Behey-Gavaid.pdf" },
        { name: "Pilot Booking Cancellation and Amendment Form", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Pilot-Booking-cancellation-and-amendment-form.pdf" },
        { name: "Access Control Gavaidh", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Access-Control-Gavaidh.pdf" },
        { name: "ETA Request", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/ETA-Request.pdf" },
        { name: "Arrival / Departure Information", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Arrival-departure-information.pdf" },
        { name: "Pilot Exemption Form", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Pilot-Exemption-form-1.pdf" },
        { name: "Lorry Queue Counter Gavaidhu", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/lorryqueuecounter.pdf" },
        { name: "Towage Operation Gavaidhu", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Towageops.pdf" },
        { name: "Hot Work Permit", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Hot-work-Permit.pdf" },
        { name: "Driver Change Request Form", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Driver-badhal-kurumah-edhey-form-1.pdf" },
        { name: "Male North Harbor Policy", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/mnhpolicy.pdf" },
        { name: "Kushuge Record Balaa Form", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Criminal-Record-form.pdf" },
      ],
    },
    {
      title: "Cargo Clearance",
      items: [
        { name: "Auction Policy", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/MPL_AUCTION_PLOICY_2022.pdf" },
        { name: "Cargo Clearance Registration Gavaidhu", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/MPL-REG-2021-02-Regulation-for-Clearing-Agents.pdf" },
        { name: "Container Shifting Gavaidhu", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Container-Shifting-Gavaidhu.pdf" },
        { name: "Express Service Gavaidhu", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/fastservice.pdf" },
        { name: "Cargo Clearing Company Registry Application Form", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Cargo-Clearing-Company-Registry-Application-Form.pdf" },
        { name: "Cargo Survey Application Form", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Survey+Application+form+2025.pdf" },
        { name: "Cargo Claims Application Form", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Short-land+Cargo+Application+form+2025.pdf" },
      ],
    },
    {
      title: "Cargo Operations",
      items: [
        { name: "Perishable Cargo Handling and Consolidation Gavaidhu", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/perishable-cargo-handling-and-consalidation-gavaidhu.pdf" },
        { name: "Transshipment Loading Request V4", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Transshipment%2BLoading%2BRequest%2BV.4+%281%29.pdf" },
        { name: "Empty Container Unloading Request V4", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Empty%2BContainer%2BUnloading%2BRequest%2BV.4+%281%29.pdf" },
      ],
    },
    {
      title: "Finance and Admin",
      items: [
        { name: "Cheque Acceptance Request – English", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Cheque-Acceptance-Request-–-English.pdf" },
        { name: "Cheque Acceptance Request – Dhivehi", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Cheque-Acceptance-Request-–-Dhivehi.pdf" },
        { name: "Rates for Landing Craft", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Rates-for-the-landing-craft.pdf" },
        { name: "Installment Application Form", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Installment-Application-Form.pdf" },
        { name: "Advance Payment Application Form", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Advance-Payment-Application-Form.pdf" },
        { name: "Water Delivery", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Water-Delivery.pdf" },
        { name: "Equipment Rental Form", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Equipment-Rental-Form.pdf" },
        { name: "Application for Refund", link: "https://mplpublic.s3.ap-southeast-1.amazonaws.com/files/Application-for-Refund.pdf" },
      ],
    },
    {
      title: "Port Training Centre",
      items: [
        { name: "Apprentice Program Application", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Application-Form_Apprentic-Programme-1.pdf" },
        { name: "Port Worker Induction Program", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Port-Worker-Induction-Program.pdf" },
        { name: "Port Worker Induction Program Application Form", link: "https://portmvuploads.s3.ap-southeast-1.amazonaws.com/files/Application-Form-1.pdf" },
      ],
    },
    {
      title: "Hulhumale Terminal",
      items: [
        { name: "Vehicle Registration Request Form", link: "https://mplpublic.s3.ap-southeast-1.amazonaws.com/files/vehicle-Registration-Request-Form.pdf" },
      ],
    },
  ];

  private loading = false;
}
</script>
